import React from 'react'
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap'
import SecBTN from '../../UI/SecBTN'
import Input from '../../UI/Input/Input'

const FacultyPaperRemove = () => {
  return (
    <div className="section">
        <h4>Faculty Paper Remove</h4>
          <Breadcrumb>
            <Breadcrumb.Item active>Faculty Paper Remove</Breadcrumb.Item>
          </Breadcrumb>
          <Row>
            <Col lg={4} md={6} sm={12}>
                 <Form.Label htmlFor="paper_id">Paper Id:</Form.Label>
                  <Input
                    required
                    type="number"
                    placeholder="Select Paper Id"
                  />
            </Col>
            <Col lg={4} md={6} sm={12}>
                 <Form.Label htmlFor="faculty_id">Faculty Id:</Form.Label>
                  <Input
                    required
                    type="number"
                    placeholder="Select Faculty Id"
                  />
            </Col>
            <Col lg={4} md={6} sm={12} className='d-flex align-items-end'><SecBTN className='sec-btn1'>Search</SecBTN></Col>
          </Row>
    </div>
  )
}

export default FacultyPaperRemove